import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentChartData } from "../../../../redux/reducers/chartSlice";
import { fetchPaymentDashboardData } from "../../../../redux/reducers/paymentDashboardSlice";
import "./RevenueAndPayment.css";
const RevenueAndPayment = () => {
  const dispatch = useDispatch();
  const { revenueReport, paymentModeCounts, loading, error, revenueBySource, paymentMethodMix } = useSelector(
    (state) => state.paymentDashboard
  );
  const { paymentsData } = useSelector((state) => state.chart);
  const [period, setPeriod] = useState("YEAR");


  const [revenueSeries, setRevenueSeries] = useState([]);
  const [paymentSeries, setPaymentSeries] = useState([]);



  useEffect(() => {
    dispatch(getPaymentChartData());
    dispatch(fetchPaymentDashboardData());
  }, [dispatch]);

  useEffect(() => {
    if (!revenueBySource && !paymentMethodMix) return;
    const revenueData = revenueBySource?.sources || [];
    const clinicData = revenueData?.find((li) => li?.source?.toLowerCase() === "clinic");
    const pharmacyData = revenueData?.find((li) => li?.source?.toLowerCase() === "pharmacy");
    const petShopData = revenueData?.find((li) => li?.source?.toLowerCase() === "pet shop");

    const revenueValues = [
      petShopData?.count || 0,
      clinicData?.count || 0,
      pharmacyData?.count || 0,
    ];

    const paymentData = paymentMethodMix?.methods || []
    const cashData = paymentData?.find((li) => li?.method?.toLowerCase() === "cash");
    const cardData = paymentData?.find((li) => li?.method?.toLowerCase() === "card");
    const upiData = paymentData?.find((li) => li?.method?.toLowerCase() === "upi");
    const advanceAdjustmentData = paymentData?.find((li) => li?.method?.toLowerCase() === "advance adjustment");

    const paymentValues = [
      parseFloat(cashData?.amount) || 0,
      parseFloat(cardData?.amount) || 0,
      parseFloat(upiData?.amount) || 0,
      parseFloat(advanceAdjustmentData?.amount) || 0,
    ];

    setRevenueSeries(revenueValues)
    setPaymentSeries(paymentValues
    );
  }, [revenueBySource, paymentMethodMix, period]);

  const revenueOptions = {
    chart: { type: "donut" },
    labels: ["Pet Shop", "Clinic", "Pharmacy"],
    colors: ["#1E3A8A", "#64748B", "#CBD5E1"],
    legend: { show: false },
    // plotOptions: { pie: { donut: { size: "0%" } } },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        const index = opts.seriesIndex;
        const value = opts.w.globals.series[index];
        const total = opts.w.globals.seriesTotals?.reduce((a, b) => a + b, 0);
        const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
        // ${value.toFixed(2)}
        return `${percentage}%`;
      },
      style: {
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
    stroke: {
      width: 0,
    },
    tooltip: {
      custom: function ({ series, seriesIndex, w }) {
        const label = w.globals.labels[seriesIndex];
        // const value = series[seriesIndex];
        // const total = series.reduce((a, b) => a + b, 0);
        // const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
        const reqData = revenueBySource?.sources?.find((li) => li?.source?.toLowerCase() === label?.toLowerCase());

        return (
          '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
          label +
          '<span class="apexcharts-tooltip-marker" style="background-color: ' +
          w.globals.colors[seriesIndex] +
          '; margin-left: 5px;"></span>' +
          "</div>" +
          '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
          '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">This Month</span>' +
          "</div>" +
          '<span class="apexcharts-tooltip-text-y-value">' +
          'Value: ' +
          "INR " +
          Number(reqData?.trend?.thisMonth ?? 0)?.toFixed(2) +
          "</span>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">Last Month</span>' +
          "</div>" +
          '<span class="apexcharts-tooltip-text-y-value">' +
          'Value: ' +
          "INR " +
          Number(reqData?.trend?.lastMonth ?? 0)?.toFixed(2) +
          "</span>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">Change in %</span>' +
          "</div>" +
          '<span class="apexcharts-tooltip-text-y-value">' +
          Number(reqData?.trend?.changePercentage ?? 0) + "%" +
          "</span>" +
          "</div>" +
          "</div>"
        );
      },
    },
  };

  const paymentOptions = {
    chart: { type: "donut" },
    labels: ["Cash", "Credit Card", "UPI", "Advance Adjustment"],
    colors: ["#1E3A8A", "#93C5FD", "#86EFAC", "#A5F3FC"],
    legend: { show: false },
    // plotOptions: { pie: { donut: { size: "70%" } } },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        const index = opts.seriesIndex;
        const value = opts.w.globals.series[index];
        const total = opts.w.globals.seriesTotals?.reduce((a, b) => a + b, 0);
        const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
        return `${percentage}%`;
      },
      style: {
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
    stroke: {
      width: 0,
    },
    tooltip: {
      custom: function ({ series, seriesIndex, w }) {
        const label = w.globals.labels[seriesIndex];
        const value = series[seriesIndex];
        const total = series.reduce((a, b) => a + b, 0);
        const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
        const labelLower = label?.toLowerCase();
        const reqData = paymentMethodMix?.methods?.find((li) => li?.method?.toLowerCase() ===
          (labelLower === 'credit card' ? 'card' : labelLower));


        return (
          '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
          label +
          '<span class="apexcharts-tooltip-marker" style="background-color: ' +
          w.globals.colors[seriesIndex] +
          '; margin-left: 5px;"></span>' +
          "</div>" +
          '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
          '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">Value: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          value.toFixed(2) +
          " (" +
          percentage +
          "%)</span>" +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">Refund: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          Number(reqData?.refunds?.amount ?? 0)?.toFixed(2) +
          " (" +
          Number(reqData?.refunds?.percentage ?? 0) +
          "%)</span>" +
          "</div>" +
          "</div>" +
          "</div>"
        );
      },
    },
  };



  if (loading && !revenueSeries.length) {
    return (
      <div className="revenue-payment-container">
        <div>Loading charts...</div>
      </div>
    );
  }

  return (
    <div className="revenue-payment-container">
      {error && (
        <div
          className="error-message"
          style={{ color: "red", marginBottom: "10px" }}
        >
          {error}
        </div>
      )}

      <div className="card">
        <div className="card-header">
          <div>
            <h4>Revenue By Source</h4>
            {/* <div className="subtitle"><span className="growth-positive">1.3%</span> vs last year</div> */}
          </div>
          {/* <select value={period} onChange={(e) => setPeriod(e.target.value)}>
            <option value="WEEK">Week</option>
            <option value="MONTH">Month</option>
            <option value="YEAR">Year</option>
          </select> */}
        </div>
        <div className="chart-legend-wrapper">
          {revenueSeries.length > 0 && (
            <Chart
              options={revenueOptions}
              series={revenueSeries}
              type="donut"
              width="100%"
            />
          )}

          <div className="legend">
            {revenueOptions.labels.map((label, idx) => (
              <div key={label}>
                <span
                  className="dot"
                  style={{ backgroundColor: revenueOptions.colors[idx] }}
                ></span>
                {label}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h4>Payment Method</h4>
          {/* <select disabled>
            <option>2025</option>
          </select> */}
        </div>
        <div className="chart-legend-wrapper">
          {paymentSeries.length > 0 && (
            <Chart
              options={paymentOptions}
              series={paymentSeries}
              type="donut"
              width="100%"
            />
          )}
          <div className="legend">
            {paymentOptions.labels.map((label, idx) => (
              <div key={label}>
                <span
                  className="dot"
                  style={{ backgroundColor: paymentOptions.colors[idx] }}
                ></span>
                {label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevenueAndPayment;
